module.exports = __webpack_public_path__ + "assets/img/gold.fabb5041.png";